// Logo da marca do portal, com o selo "Atendimento Vigor Energy" quando a marca é de uma
// parceira atendida pela Vigor (#6117 — o vínculo é com a Gran, o atendimento é da Vigor).
import React from 'react';
import { useMarcaPortal } from './MarcaPortalContext';

interface Props {
  /** 'cabecalho' = barra do topo das telas; 'login' = painel da tela de entrada; 'cartao' = centro de um cartão. */
  variante?: 'cabecalho' | 'login' | 'cartao';
  className?: string;
  /** Só a logo da marca, sem o selo da Vigor (ex.: comunicado, cuja arte já mostra as duas marcas). */
  semSelo?: boolean;
}

const LogoMarcaPortal: React.FC<Props> = ({ variante = 'cabecalho', className = '', semSelo = false }) => {
  const { marca } = useMarcaPortal();
  const altura = variante === 'cabecalho' ? 'h-10 sm:h-12' : variante === 'login' ? 'h-16 sm:h-20' : 'h-16';
  const logo = (
    <img
      src={marca.logo.src}
      alt={marca.logo.alt}
      className={`${altura} w-auto object-contain ${variante === 'login' ? 'bg-white rounded-2xl px-5 py-2.5 shadow-lg' : ''}`}
    />
  );
  if (!marca.seloAtendimentoVigor || semSelo) return <span className={`inline-flex ${className}`}>{logo}</span>;

  return (
    <span className={`inline-flex items-center gap-3 ${variante === 'cartao' ? 'flex-col' : ''} ${className}`}>
      {logo}
      <span
        className={`items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold whitespace-nowrap ${
          // No cabeçalho (barra fixa h-16, sem quebra de linha) o selo por extenso não cabe
          // ao lado do logo em celular — some abaixo de `sm`, como já acontece com "Portal
          // do Consumidor" no mesmo header.
          variante === 'cabecalho' ? 'hidden sm:inline-flex' : 'inline-flex'
        } ${variante === 'login'
          ? 'border-white/30 bg-white/15 text-white'
          : 'border-gray-200 bg-white text-gray-500'}`}
        title="O atendimento e os boletos da Gran são feitos pela Vigor Energy"
      >
        <img src="/LOGO-01.png" alt="" aria-hidden="true" className="h-4 w-auto object-contain" />
        Atendimento Vigor Energy
      </span>
    </span>
  );
};

export default LogoMarcaPortal;
